import { Component, computed, inject, input } from '@angular/core';
import { NodeGdover, NodeGuide } from '@app/models/entity.model';
import { GuideListComponent } from '@app/components/guide-list/guide-list.component';
import { MediaComponent } from '@app/components/media/media.component';
import { TextComponent } from '@app/components/text/text.component';
import { BreadcrumbComponent } from '@app/components/breadcrumb/breadcrumb.component';
import { BreakpointService } from '@app/services/breakpoint.service';
import { EntitySharedModule } from '@app/modules/entity.shared.module';
import { ContentSectionComponent } from '@app/components/content-section/content-section.component';
import { IsNewComponent } from '@app/components/is-new/is-new.component';
import { RatingCounterComponent } from '@app/components/rating-counter/rating-counter.component';
import { StripHtmlPipe } from '@app/pipes/strip-html.pipe';
import { ExtractUrlPipe } from '@app/pipes/extract-url.pipe';
import { GuideViewComponent } from '@app/components/guide-view/guide-view.component';

@Component({
  selector: 'mobi-node-gdover',
  templateUrl: './node-gdover.component.html',
  styleUrls: ['./node-gdover.component.scss'],
  imports: [
    EntitySharedModule,
    GuideListComponent,
    MediaComponent,
    TextComponent,
    BreadcrumbComponent,
    ContentSectionComponent,
    IsNewComponent,
    RatingCounterComponent,
    StripHtmlPipe,
    ExtractUrlPipe,
    IsNewComponent,
    RatingCounterComponent,
    GuideViewComponent,
  ],
  standalone: true,
})
export class NodeGdoverComponent {
  readonly entity = input.required<NodeGdover>();

  breakpoint = inject(BreakpointService);

  mobileArticles = computed<NodeGuide[]>(() => [
    this.entity().promotedArticleLarge || {},
    ...(this.entity().promotedArticlesSmall || []),
  ]);
}
